import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Payroll } from '@app/models/payroll/payroll.model';
import { PayrollStates } from '@app/modules/payroll/enums/payroll-state.enum';
import { AuthService } from '@app/services';

@Injectable()
export class PayrollPendingStateResolver {
    constructor(
        protected auth: AuthService,
        protected router: Router
    ) {}

    async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
        const safeResolve = _route.data['safeResolve'] ?? false;

        let isPayrollPending = false;

        try {
            const [pendingPayrolls] = await Payroll.param('company', this.auth.company.id)
                .where('states', [PayrollStates.Pending])
                .get();

            isPayrollPending = Boolean(pendingPayrolls.length);
        } catch (error) {
            if (!safeResolve) {
                throw error;
            }
        }

        return isPayrollPending;
    }
}
